// a etapa 1 grava o grupo 69 na venda como "EM FORMAÇÃO"; os dois valores indicam grupo em formacao
export function grupoEmFormacao(grupo: any) {
  const valor = String(grupo ?? '').trim().toUpperCase()
  return valor === '69' || valor === 'EM FORMAÇÃO'
}

// em grupo em formacao, a reducao de 30% acrescenta 1% na taxa de administracao e a de 50% acrescenta 2%.
// o backend ja devolve as parcelas com esse acrescimo; aqui so ajustamos a taxa exibida/gravada na venda
export function acrescimoTaxaReducao(grupo: any, reducao: number) {
  if (!grupoEmFormacao(grupo)) return 0
  if (reducao === 30) return 1
  if (reducao === 50) return 2
  return 0
}
